import React, { useState } from 'react';
import NoSuppliers from './NoSuppliers';
import SuppliersList from './SuppliersList';
import AddSuppliers from './AddSuppliers'

function SuppliersView({ productId, productName, history, suppliers, auth, refreshList }) {
    console.log('SuppliersView history ', history )
    const [showAddSupplier, setShowAddSupplier] = useState(false)
    return (
        <div className="supplierslist-wrapper border-1-radius">
            {suppliers.length > 0
                ? 
                <span>
                    <AddSuppliers productId={productId} history={history} />
                    <SuppliersList
                        history={history}
                        productId={productId}
                        productName={productName}
                        auth={auth}
                        refresh_products={refreshList}
                    />
                </span>
                : showAddSupplier
                    ? <AddSuppliers productId={productId} history={history} />
                    : <NoSuppliers setShowAddSupplier={setShowAddSupplier} history={history} />
            }
        </div>
    )
}

export default SuppliersView;